module.exports = "<p>\n  dice works!\n</p>\n"